export const TWO_FA_CODE_RESEND_TIME = 180;
export const SET_HEADERS_EXCLUDE_PATHS = [
  '/verification/start/login',
  '/verification/complete',
  '/auth/login',
];
export const PAGINATION_DEFAULT_LIMIT = 50;
export const DOCUMENT_HIDDEN_SESSION_EXPIRE = 10;
